import { humanizeToken } from './inlineAttribution';

/**
 * How a `parcel_values` row NAMES ITSELF, everywhere it is shown.
 *
 * A value is an appeal event (§2.1), so its identity is the forum it happened in
 * and the event that happened there — "ARB · ARB Decision". `value_type` is the
 * structural slot the row occupies for the tax year, derived from the forum by a
 * deliberately lossy map (`ARB`/`BOE`/`Board of Review` all collapse to
 * `formal_hearing`), and it is NOT what an operator calls the record.
 *
 * ⚠️ THIS EXISTS BECAUSE THE TWO SCREENS DISAGREED. The parcel's Values tab
 * labelled a box by forum·event while the value's own detail page titled itself
 * from `value_type` — so keying a value as ARB on one screen opened a page headed
 * "Formal Hearing", and the operator reasonably read that as the system having
 * silently changed their entry. Same row, same instant, two names. Both callers
 * now go through here, so a change to the naming rule cannot reach one screen and
 * miss the other.
 *
 * The `value_type` fallback is load-bearing, not decoration: `forum`/`event` were
 * added later, so every row written before them carries NULL in both and the slot
 * name is the only thing left to say about it.
 */
export function valueFaceLabel(
  v: { forum?: string | null; event?: string | null; value_type?: string | null },
): string {
  const parts = [v.forum, v.event].filter(Boolean) as string[];
  if (parts.length) return parts.join(' · ');
  return v.value_type ? humanizeToken(v.value_type) : '—';
}
